import React from "react";
import { useContextHook } from "../../Context/ContextOPen";

function MainButton({ name, className, index, onClick }) {
  const { swiperIndex } = useContextHook();
  return (
    <button
      onClick={onClick}
      type="submit"
      className={
        "border border-Main hoverMain w-fit my-4 px-10 py-2 rounded-md after:bg-Main relative overflow-hidden" +
        className +
        " " +
        (swiperIndex === index ? " button " : "")
      }
    >
      <span className="z-10 relative">{name}</span>
    </button>
  );
}

export default MainButton;
